// extracted by mini-css-extract-plugin
export default {"categoryDescription":"index_categoryDescription__3u5pT","heading":"index_heading__2BcYm"};